import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const SearchInput = ({
    value,
    placeholder,
    onChange,
    width = "w-[280px]",
    className = "",
}) => {
    return (
        <div
            className={`
        flex items-center gap-2 px-4 py-2 rounded-xl
        border border-border-light dark:border-border-dark
        bg-bg-light-secondary dark:bg-bg-dark-secondary
        text-gray-700 dark:text-gray-300
        transition-all duration-300
        dark:focus-within:border-primary focus-within:border-primary-light
        focus-within:shadow-[0_0px_24px_rgba(0,255,157,0.25)]
        group
        ${width}
        ${className}
      `}
        >
            <MagnifyingGlassIcon
                className="w-5 h-5 text-gray-400 transition-colors duration-300 dark:group-focus-within:text-primary group-focus-within:text-primary-light"
            />

            <input
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                className="w-full text-sm text-gray-700 placeholder-gray-400 bg-transparent outline-none dark:text-gray-300 dark:placeholder-gray-500"
            />
        </div>
    );
};

export default SearchInput;
